import React,{useMemo,useState} from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import {parseContent,qrTypes} from '../data/qrTypes';

const defaults={
  url: {value: ''},
  text: {value: ''},
  email: {email: '',subject: '',body: ''},
  phone: {value: ''},
  wifi: {ssid: '',password: '',security: 'WPA',hidden: false},
  contact: {name: '',phone: '',email: '',company: '',note: ''},
  event: {title: '',start: '',location: '',description: ''},
  location: {latitude: '',longitude: '',label: ''},
  crypto: {network: 'bitcoin',address: '',amount: '',memo: ''},
  social: {profile: ''},
  file: {url: ''},
  more: {value: ''}
};

function ContentFields({type,data,update}) {
  const field=(key,label,placeholder,typeName='text')=> (
    <label className="content-field" key={key}>
      <span>{label}</span>
      <input
        type={typeName}
        value={data[key] || ''}
        onChange={(event)=> update(key,event.target.value)}
        placeholder={placeholder}
      />
    </label>
  );

  if (type==='text') {
    return (
      <label className="content-field">
        <span>Text content</span>
        <textarea
          value={data.value || ''}
          onChange={(event)=> update('value',event.target.value)}
          placeholder="Write anything…"
        />
      </label>
    );
  }

  if (type==='url') {
    return field('value','Website URL','https://godqr.com','url');
  }

  if (type==='email') {
    return (
      <div className="content-form-grid">
        {field('email','Email address','hello@example.com','email')}
        {field('subject','Subject','Your subject')}
        {field('body','Message','Write a message')}
      </div>
    );
  }

  if (type==='wifi') {
    return (
      <div className="content-form-grid">
        {field('ssid','Network name','My Wi-Fi')}
        {field('password','Password','Network password','password')}
        <label className="content-field">
          <span>Security</span>
          <select
            value={data.security}
            onChange={(event)=> update('security',event.target.value)}
          >
            <option>WPA</option>
            <option>WEP</option>
            <option>nopass</option>
          </select>
        </label>
        <label className="check-field">
          <input
            type="checkbox"
            checked={data.hidden}
            onChange={(event)=> update('hidden',event.target.checked)}
          />
          Hidden network
        </label>
      </div>
    );
  }

  if (type==='contact') {
    return (
      <div className="content-form-grid">
        {field('name','Full name','Jordan Davis')}
        {field('phone','Phone','+1 555 123 4567','tel')}
        {field('email','Email','jordan@example.com','email')}
        {field('company','Company','GodQR')}
        {field('note','Notes','Optional note')}
      </div>
    );
  }

  if (type==='event') {
    return (
      <div className="content-form-grid">
        {field('title','Event title','Product launch')}
        {field('start','Start date and time','','datetime-local')}
        {field('location','Location','Studio A')}
        {field('description','Description','Event details')}
      </div>
    );
  }

  if (type==='location') {
    return (
      <div className="content-form-grid">
        {field('latitude','Latitude','40.7128','number')}
        {field('longitude','Longitude','-74.0060','number')}
        {field('label','Place label','New York')}
      </div>
    );
  }

  if (type==='crypto') {
    return (
      <div className="content-form-grid">
        <label className="content-field">
          <span>Network</span>
          <select
            value={data.network}
            onChange={(event)=> update('network',event.target.value)}
          >
            <option value="bitcoin">Bitcoin</option>
            <option value="ethereum">Ethereum</option>
            <option value="solana">Solana</option>
          </select>
        </label>
        {field('address','Wallet address','Wallet address')}
        {field('amount','Amount','Optional amount','number')}
        {field('memo','Memo','Optional memo')}
      </div>
    );
  }

  if (type==='phone') return field('value','Phone number','+1 555 123 4567','tel');
  if (type==='social') return field('profile','Profile URL','https://instagram.com/yourname','url');
  if (type==='file') return field('url','Hosted file URL','https://example.com/file.pdf','url');
  return field('value','Content','Enter a URL, code, or custom URI');
}

function ContentPanel({type,setType,value,setValue}) {
  const selected=qrTypes.find((item)=> item.id===type);
  const [showMore,setShowMore]=useState(false);
  const data=useMemo(
    ()=> parseContent(value,defaults[type] || defaults.more),
    [type,value]
  );

  function update(key,nextValue) {
    setValue(JSON.stringify({...data,[key]: nextValue}));
  }

  function selectType(nextType) {
    setType(nextType);
    setValue(JSON.stringify(defaults[nextType] || defaults.more));
  }

  function resetContent() {
    setValue(JSON.stringify(defaults[type] || defaults.more));
  }

  return (
    <section className="editor-card">
      <div className="section-heading">
        <span className="step">1</span>
        <div>
          <h2>Add your content</h2>
          <p>Choose what happens when someone scans.</p>
        </div>
        <button
          className="surprise"
          type="button"
          onClick={resetContent}
          aria-label="Clear content fields"
        >
          <SafeIcon icon={FiIcons.FiRotateCcw} />
          Reset
        </button>
      </div>
      <div className="type-grid">
        {qrTypes.map((item)=> (
          <button
            key={item.id}
            className={`type-button ${type===item.id ? 'selected' : ''}`}
            onClick={()=> item.id==='more' ? setShowMore(!showMore) : selectType(item.id)}
            type="button"
          >
            <SafeIcon icon={item.icon} />
            <span>{item.label}</span>
          </button>
        ))}
      </div>
      {showMore && (
        <div className="more-content-menu">
          {['Custom URI','Raw data','WhatsApp message','Telegram message'].map((item)=> (
            <button
              key={item}
              type="button"
              onClick={()=> {
                selectType('more');
                setShowMore(false);
              }}
            >
              {item}
            </button>
          ))}
        </div>
      )}
      <div className="content-fields">
        <div className="content-type-label">
          <SafeIcon icon={selected?.icon || FiIcons.FiLink} />
          {selected?.label || 'Content'}
        </div>
        <ContentFields type={type} data={data} update={update} />
      </div>
      <div className="smart-row">
        <span>
          <SafeIcon icon={FiIcons.FiZap} />
          Smart URL detection is on
        </span>
        <button type="button">
          UTM builder <SafeIcon icon={FiIcons.FiArrowUpRight} />
        </button>
      </div>
    </section>
  );
}

export default ContentPanel;